import React from 'react';
import {ReactComponent as EditIcon} from '../../../../../../../assets/main/groups/main-top/edit.svg';
import {useAppDispatch, useAppSelector} from "common/hook";
import {setEditAC} from "app/popups-reducer";
import {ROLE_TEACHER} from "entities/constants/constants";
import {LessonData} from "features/model/types/lessosnSchema";
import {NothingYetMessage} from "../../../../../personal-cabinet/nothing-yet-message/NothingYetMessage";
import {useParams} from "react-router-dom";


interface IDetailsNote {
    lesson: LessonData;
}

export const DetailsNote = ({lesson}: IDetailsNote) => {
    const roleType = useAppSelector((state) => state.role.roleType);
    const isEdit = useAppSelector((state) => state.popups.isEdit);
    const noteData = useAppSelector((state) => state.note);
    const {lessonsId} = useParams();
    const dispatch = useAppDispatch();

    const onClickHandler = () => {
        dispatch(setEditAC(!isEdit));
    };


    const displayNote = lesson.note || noteData.note || '';

    return (
        <div className="info-card">
            <div className="info-card-hdr">
                <div className="title-box">
                    <p className="info-card-title h6">Заметка</p>
                </div>
                {/*{roleType === ROLE_TEACHER && lesson.status !== 'finished' && (*/}
                {roleType === ROLE_TEACHER && (
                    <span className="small-edit-btn pointer-elem" onClick={onClickHandler}>
                        <EditIcon/>
                    </span>
                )}
            </div>
            {displayNote ? (
                <div className="info-card-content">
                    <p>{lesson.note}</p>
                </div>
            ) : (
                <div className="info-card-content">
                    <NothingYetMessage/>
                </div>
            )}
        </div>
    );
};
